import { repositoryActions } from '../services';
export const apiException = ( response, dispatch, hidePopup, hide = false ) => {
  let message = {
    messageType: 'warning',
    messageText: 'Internal Server Error occured, please refresh the page',
    timeout: 0,
    id: new Date().toTimeString()
  };
  if( response.data === "" || response.data === null ){
    dispatch( {
      type: repositoryActions('message').SET,
      item: message
    } );
    hide && hidePopup?.()
    return;
  }
};